import {Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter, AfterViewInit, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {PageNotificationService} from "@signature-it/ngx-generic/services";
import { distinctUntilChanged, debounceTime, map } from 'rxjs/operators';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { SharedDataService } from "@signature-it/ngx-catalogue/services";

declare let $: any;
declare let _: any;
let quantityCounter = 0;

@Component({
    selector: 'quantity-selector',
    templateUrl: './quantity-selector.component.html',
    styleUrls: ['./quantity-selector.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [],
    standalone: false
})
export class QuantitySelectorComponent implements AfterViewInit, OnChanges {

    unCommerceApp: boolean = GenericConfig.unCommerceApp || false;
    quantityId = `quantity-input-${quantityCounter++}`;
    @Input() id: any;
    @Input('quantity') fixLotMultiplier: number;
    @Input() minQty: number = 0;
    @Input() maxQty: number;
    @Input() value: number = 0;
    @Input() disabled: boolean = false;
    @Input() mode: string = 'center';

    @Output() qtyChanged = new EventEmitter();

    @ViewChild('qtyMdl') qtyMdl;

    public quantity;


    constructor(public notifySvc: PageNotificationService, public sharedSvc: SharedDataService) {
    }


    ngAfterViewInit() {
        // if(_.isUndefined(this.minQty)) {
        //     this.minQty = 1;
        // }
        this.qtyMdl.valueChanges.pipe(
            debounceTime(10),
            distinctUntilChanged(),
            map(value => {
                this.roundUp(value);
            })
        ).subscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        let prevQuantity = this.quantity;
        if (changes.value && Number.isInteger(changes.value.currentValue)) this.quantity = changes.value.currentValue;
        if (changes.id && changes.id.currentValue !== changes.id.previousValue) this.quantity = this.value;
        if (changes.minQty && changes.minQty.currentValue > this.quantity) this.quantity = changes.minQty.currentValue;
        if (changes.maxQty && changes.maxQty.currentValue < this.quantity) this.quantity = changes.maxQty.currentValue;
        if (changes.maxQty && changes.maxQty.previousValue < changes.maxQty.currentValue) this.quantity = this.value;
        if (prevQuantity !== this.quantity) this.qtyChanged.next({id: this.id, qty: this.quantity});
    }

    FixedLotDialog() {
        this.notifySvc.set(`This item is available in multiples of ${this.fixLotMultiplier} Quantity adjusted to ${this.quantity}`, 400).show();
    };

    isValid(qty) {
        if(_.isUndefined(qty) || parseInt(qty) <= 0 || _.isNaN(qty) || qty == "" || parseInt(qty) <= this.minQty) {
            this.quantity = this.minQty;
        }
        else{
            if((this.maxQty || this.maxQty == 0) && this.quantity >= this.maxQty){
                this.quantity = this.maxQty;
            }
        }
    };

    qtyUp() {
        if(this.disabled) return;
        if(this.maxQty && this.quantity >= this.maxQty) return;
        this.isValid(this.quantity);
        this.quantity = parseInt(this.quantity) + this.fixLotMultiplier;
        this.qtyChanged.next({id: this.id, qty: this.quantity});
    };

    qtyDown() {
        if(this.disabled) return;
        this.isValid(this.quantity);
        if(this.quantity > this.minQty * this.fixLotMultiplier) {
            this.quantity = this.quantity - this.fixLotMultiplier;
            this.qtyChanged.next({id: this.id, qty: this.quantity});
        }
    };

    roundUp(qty) {
        this.isValid(qty);
        var qtyCurrent = this.quantity;
        this.quantity = this.fixLotMultiplier * (Math.ceil(qtyCurrent / this.fixLotMultiplier));
        this.qtyChanged.next({id: this.id, qty: this.quantity});
        if(this.fixLotMultiplier > 1 && qtyCurrent != this.quantity) {
            this.FixedLotDialog();
        }
    };
}
